import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from "ng-nice-select";

import { ProfileRoutingModule } from '@teem/customer/profile/profile-routing.module';
import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { ProfileComponent } from '@teem/customer/profile/profile.component';
import { UserInfoComponent } from '@teem/customer/profile/user-info/user-info.component';
import { ActionCardsComponent } from '@teem/customer/profile/action-cards/action-cards.component';
import { OrderSectionComponent } from '@teem/customer/profile/order-section/order-section.component';
import { OrderDetailAccordionComponent } from '@teem/customer/profile/order-section/order-detail-accordion/order-detail-accordion.component';
import { OrderDetailComponent } from '@teem/customer/profile/order-section/order-detail/order-detail.component';
import { AddressModalComponent } from '@teem/customer/modals/address-modal/address-modal.component';
import { SigninModalComponent } from '@teem/customer/modals/signin-modal/signin-modal.component';
import { SignupModalComponent } from '@teem/customer/modals/signup-modal/signup-modal.component';
import { OrderStatusHistoryComponent } from '@teem/customer/profile/order-section/order-status-history/order-status-history.component';
import { AccountSettingsModalComponent } from '@teem/customer/modals/account-settings-modal/account-settings-modal.component';
import { SigninComponent } from '@teem/customer/signin/signin.component';
import { SignupComponent } from '@teem/customer/signup/signup.component';
import { ForgotPasswordComponent } from '@teem/customer/forgot-password/forgot-password.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AgmCoreModule } from '@agm/core';
import { environment } from '@teem/environments/environment';
@NgModule({
  declarations: [
    ProfileComponent,
    UserInfoComponent,
    ActionCardsComponent,
    OrderSectionComponent,
    OrderDetailAccordionComponent,
    OrderDetailComponent,
    AddressModalComponent,
    SigninModalComponent,
    SignupModalComponent,
    OrderStatusHistoryComponent,
    AccountSettingsModalComponent,
    SigninComponent,
    SignupComponent,
    ForgotPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    NgxPaginationModule,
    ProfileRoutingModule,
    NgxIntlTelInputModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey,
      libraries: ['geometry', 'places']
    })
  ],
  // exports: [ProfileComponent]
})
export class ProfileModule {}